export default class ServiceCode {
    constructor(element) {
      this.el = element
      this.password = this.el.querySelector('#service-password');
      this.verifypassword = this.el.querySelector('#verify-service-password');
      this.submitbutton = this.el.querySelector('#btn-service-code');
      this.errornomatch = this.el.querySelector('#error-no-match');
      this.errornoinput = this.el.querySelector('#error-no-servicecode');
      this.errornoinput = this.el.querySelector('#error-no-servicecode');

      this.matchPassword = this.matchPassword.bind(this);
      this.checkEmptyPassword = this.checkEmptyPassword.bind(this);
      this.init()
    }
  
    init() {
        this.submitbutton.addEventListener('click', e =>{
          this.checkEmptyPassword();
        })
        this.verifypassword.addEventListener('blur', e =>{
            this.checkEmptyPassword();
        })
    }

      checkEmptyPassword(){
        if (this.password.value == '' && this.verifypassword.value == '') {
            this.errornoinput.classList.remove("hidden");
        }
        else {
            this.errornoinput.classList.add("hidden");
            this.matchPassword(); 
        }
      }

      matchPassword(){
        if (this.password.value != this.verifypassword.value) {
            this.errornomatch.classList.remove("hidden");
        }
        else {
            this.errornomatch.classList.add("hidden");
            this.verifypassword.class;
        }
      }

  }
  